const accessAssign = {
    ASSIGN_SUBJECT_TEACHER_LIST: { name: 'Assign Subject Teacher', path: '/assign-subject-teacher-list' },
    ADD_ASSIGN_SUBJECT_TEACHER: { name: 'Add Assign Subject Teacher', path: '/add-assign-subject-teacher' },
    UPDATE_ASSIGN_SUBJECT_TEACHER: { name: 'Edit Assign Subject Teacher', path: '/edit-assign-subject-teacher' },
    DELETE_ASSIGN_SUBJECT_TEACHER: { name: 'Delete Assign Subject Teacher', path: '/delete-assign-subject-teacher' },

    ASSIGN_COURSE_SUBJECT_LIST: { name: 'Assign Course Subject', path: '/assign-course-subject-list' },
    ADD_ASSIGN_COURSE_SUBJECT: { name: 'Add Assign Course Subject', path: '/add-assign-course-subject' },
    UPDATE_ASSIGN_COURSE_SUBJECT: { name: 'Update Assign Course Subject', path: '/edit-assign-course-subject' },
    DELETE_ASSIGN_COURSE_SUBJECT: { name: 'Delete Assign Course Subject', path: '/delete-assign-course-subject' }
}

export default accessAssign;
